/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes, { string } from 'prop-types';
import { ChevronDownIcon, ChevronUpIcon, PencilIcon, SaveIcon } from '@heroicons/react/solid';
import { Loader } from 'components/indicators/loader';

const DataColumn = ({ name, dbColumnName, headerClass, onSort, sort, oppositeSort, editSettings, onEdit, isEditing, isSavingEdit }) => {
  const isThisSort = sort?.field === dbColumnName;
  const isDescending = !isThisSort || sort?.order === (oppositeSort ? 1 : -1);

  return (
    <th scope="col" className={headerClass}>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();

          if (onSort) {
            // eslint-disable-next-line no-nested-ternary
            onSort(isThisSort ? (isDescending
              ? (oppositeSort ? -1 : 1)
              : (oppositeSort ? 1 : -1)) : (oppositeSort ? 1 : -1));
          }
        }}
        className="inline-flex items-center"
      >
        {name}
        {!!onSort && (
        <span className={isThisSort
          ? 'ml-1 flex-none rounded bg-gray-200 text-gray-900 hover:bg-gray-300'
          : 'ml-1 flex-none rounded text-gray-400 hover:visible focus:visible'}
        >
          {isDescending
            ? <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
            : <ChevronUpIcon className="h-5 w-5" aria-hidden="true" />}
        </span>
        )}
        {!!editSettings && !isSavingEdit && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onEdit(editSettings.valueField, editSettings.dbField);
          }}
          className="ml-1 flex-none rounded text-gray-900"
        >
          {isEditing ? <SaveIcon className="h-4 w-4" /> : <PencilIcon className="h-4 w-4" />}
        </button>
        )}
        {isSavingEdit && <div className="ml-1"><Loader xxs /></div>}
      </a>
    </th>
  );
};

DataColumn.defaultProps = {
  __TYPE: 'DataColumn',
  dbColumnName: string,
  name: string,
  headerClass: string,
  dataCellClass: string,
  children: PropTypes.node,
  render: PropTypes.func,
};

export { DataColumn };
